const routes = [
  {
    path: 'text3D',
    name: 'text3D',
    component: () => import(/* webpackChunkName: "text3D" */ '@/modules/text3D/index.vue')
  },
];

export default routes;